import { useMemo } from 'react';
import { useProfile } from './useProfile';
import { usesMetricSystem, getDistanceOptions } from '@/utils/distanceUnits';

/**
 * Hook to get distance unit preferences based on user's location
 */
export const useDistanceUnits = () => {
  const { profile } = useProfile();
  
  const isMetric = useMemo(() => {
    return usesMetricSystem(profile?.location);
  }, [profile?.location]);
  
  const distanceOptions = useMemo(() => {
    return getDistanceOptions(isMetric);
  }, [isMetric]);
  
  return {
    isMetric,
    distanceOptions,
    unitSymbol: isMetric ? 'km' : 'mi'
  };
};
